import { saveAs } from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';
import axiosPrivate from 'config/axiosPrivate';
import { fileNameSanitizer } from 'helpers/FileNameSanitizer';
import he from 'he';

export const DownloadTextWordType = async (textId, user) => {
  try {
    const response = await axiosPrivate.get(`/texts/external/${textId}/fullDetails`);
    const text = response.data;

    const keywords = text.title || text.keyword || text.textTitle || 'Sans titre';
    const titleTag = text.titleTag || '';
    const metaDescription = text.metaDescriptionTag || '';
    const url = text.url || '';

    // Utiliser actualHtmlContent si disponible pour préserver la mise en forme
    let htmlContent = '';
    if (text.actualHtmlContent) {
      // Décoder les entités HTML pour obtenir le HTML propre
      htmlContent = he.decode(text.actualHtmlContent);
    } else {
      // Fallback sur le texte brut si pas de HTML
      const textContent = text.actualTextContent || 
                         text.content || 
                         text.text || 
                         '';
      htmlContent = escapeHtml(textContent).replace(/\n/g, '<br/>');
    }

    const htmlString = `
      <html>
        <head>
          <meta charset="utf-8">
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            h1 {
              font-size: 18pt;
              font-weight: bold;
              margin-bottom: 30px;
              color: #333;
              text-align: center;
            }
            .metadata {
              margin-bottom: 30px;
              padding: 15px;
              background-color: #f5f5f5;
              border-left: 4px solid #333;
            }
            .metadata-item {
              margin-bottom: 10px;
              font-size: 11pt;
            }
            .metadata-label {
              font-weight: bold;
              color: #555;
              display: inline-block;
              width: 150px;
            }
            .metadata-value {
              color: #000;
            }
            p, div {
              font-size: 12pt;
              line-height: 1.6;
              color: #000;
              text-align: justify;
            }
            strong, b {
              font-weight: bold;
            }
            em, i {
              font-style: italic;
            }
            u {
              text-decoration: underline;
            }
            [style*="color"] {
              color: inherit;
            }
          </style>
        </head>
        <body>
          <h1>${escapeHtml(keywords)}</h1>
          
          <div class="metadata">
            ${titleTag ? `
              <div class="metadata-item">
                <span class="metadata-label">Titre :</span>
                <span class="metadata-value">${escapeHtml(titleTag)}</span>
              </div>
            ` : ''}
            ${metaDescription ? `
              <div class="metadata-item">
                <span class="metadata-label">Meta-description :</span>
                <span class="metadata-value">${escapeHtml(metaDescription)}</span>
              </div>
            ` : ''}
            ${url ? `
              <div class="metadata-item">
                <span class="metadata-label">URL :</span>
                <span class="metadata-value">${escapeHtml(url)}</span>
              </div>
            ` : ''}
          </div>
          
          <div>${htmlContent}</div>
        </body>
      </html>
    `;

    // Convertir le HTML en document Word
    const fileBuffer = htmlDocx.asBlob(htmlString);

    // Sanitizer le nom du fichier
    const fileName = fileNameSanitizer(keywords);

    // Télécharger le fichier
    saveAs(fileBuffer, `${fileName}.docx`);
  } catch (error) {
    console.error('Erreur lors du téléchargement du document Word:', error);
    throw error;
  }
};

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function stripHtmlTags(html) {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}

export const DownloadOneTextWordType = async (textId, user) => {
  return DownloadTextWordType(textId, user);
};

export const downloadHtmlFromContent = (htmlContent, fileName = 'document') => {
  if (!htmlContent) {
    console.warn('[Tiny] Impossible de télécharger en HTML: contenu manquant');
    return;
  }

  const decoded = he.decode(htmlContent);
  const blob = new Blob([decoded], { type: 'text/html;charset=utf-8' });
  saveAs(blob, `${fileNameSanitizer(fileName)}.html`);
};

export const DownloadTextsListWordType = async (data, user, setShowDownloadModel) => {
  let timeout;
  if (setShowDownloadModel) {
    timeout = setTimeout(() => setShowDownloadModel(true), 500);
  }
  
  const zip = require('jszip')();
  
  const files = await Promise.all(
    data.map(async (text) => {
      try {
        const response = await axiosPrivate.get(`/texts/external/${text.id}/fullDetails`);
        const textData = response.data;
        const keywords = textData.title || textData.keyword || textData.textTitle || 'Sans titre';
        const titleTag = textData.titleTag || '';
        const metaDescription = textData.metaDescriptionTag || '';
        const url = textData.url || '';
        
        let htmlContent = '';
        if (textData.actualHtmlContent) {
          htmlContent = he.decode(textData.actualHtmlContent);
        } else {
          const textContent = textData.actualTextContent || 
                            textData.content || 
                            textData.text || 
                            '';
          htmlContent = escapeHtml(textContent).replace(/\n/g, '<br/>');
        }
        
        const htmlString = `
          <html>
            <head>
              <meta charset="utf-8">
              <style>
                body {
                  font-family: Arial, sans-serif;
                  padding: 20px;
                }
                h1 {
                  font-size: 18pt;
                  font-weight: bold;
                  margin-bottom: 30px;
                  color: #333;
                  text-align: center;
                }
                .metadata {
                  margin-bottom: 30px;
                  padding: 15px;
                  background-color: #f5f5f5;
                  border-left: 4px solid #333;
                }
                .metadata-item {
                  margin-bottom: 10px;
                  font-size: 11pt;
                }
                .metadata-label {
                  font-weight: bold;
                  color: #555;
                  display: inline-block;
                  width: 150px;
                }
                .metadata-value {
                  color: #000;
                }
                p, div {
                  font-size: 12pt;
                  line-height: 1.6;
                  color: #000;
                  text-align: justify;
                }
                strong, b {
                  font-weight: bold;
                }
                em, i {
                  font-style: italic;
                }
                u {
                  text-decoration: underline;
                }
                [style*="color"] {
                  color: inherit;
                }
              </style>
            </head>
            <body>
              <h1>${escapeHtml(keywords)}</h1>
              
              <div class="metadata">
                ${titleTag ? `
                  <div class="metadata-item">
                    <span class="metadata-label">Titre :</span>
                    <span class="metadata-value">${escapeHtml(titleTag)}</span>
                  </div>
                ` : ''}
                ${metaDescription ? `
                  <div class="metadata-item">
                    <span class="metadata-label">Meta-description :</span>
                    <span class="metadata-value">${escapeHtml(metaDescription)}</span>
                  </div>
                ` : ''}
                ${url ? `
                  <div class="metadata-item">
                    <span class="metadata-label">URL :</span>
                    <span class="metadata-value">${escapeHtml(url)}</span>
                  </div>
                ` : ''}
              </div>
              
              <div>${htmlContent}</div>
            </body>
          </html>
        `;
        
        const fileBuffer = htmlDocx.asBlob(htmlString);
        const fileName = fileNameSanitizer(keywords);
        
        return {
          name: `${fileName}.docx`,
          data: fileBuffer,
        };
      } catch (error) {
        console.error(`Erreur lors du téléchargement du texte ${text.id}:`, error);
        return null;
      }
    })
  );
  
  const validFiles = files.filter(f => f !== null);
  validFiles.forEach((file) => zip.file(file.name, file.data));
  
  zip.generateAsync({ type: 'blob' }).then((content) => {
    saveAs(content, 'allFiles.zip');
    if (setShowDownloadModel) {
      setShowDownloadModel(false);
    }
  });
};